import { render, staticRenderFns } from "./DataImporting.vue?vue&type=template&id=b8f41e08&scoped=true"
import script from "./DataImporting.vue?vue&type=script&lang=ts"
export * from "./DataImporting.vue?vue&type=script&lang=ts"
import style0 from "./DataImporting.vue?vue&type=style&index=0&id=b8f41e08&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f41e08",
  null
  
)

export default component.exports